import React, { useEffect, useMemo, useRef } from "react";

import JoditEditor from "jodit-react";
import sanitizeHtml from "sanitize-html";

const SANITIZE_OPTIONS = {
  allowedTags: [
    "a",
    "b",
    "blockquote",
    "br",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "i",
    "li",
    "ol",
    "p",
    "pre",
    "strong",
    "table",
    "tbody",
    "td",
    "th",
    "thead",
    "tr",
    "u",
    "ul",
  ],
  allowedAttributes: {
    "*": ["style"],
    a: ["href"],
    td: ["colspan", "rowspan", "align"],
    th: ["colspan", "rowspan", "align"],
    tr: ["align"],
    table: ["cellspacing", "cellpadding", "border"],
  },
  allowedStyles: {
    "*": {
      "text-align": [/^(left|right|center|justify)$/],
      "padding-left": [/^\d+(\.\d+)?(px|em|rem|%)$/],
      "margin-left": [/^\d+(\.\d+)?(px|em|rem|%)$/],
    },
    td: { width: [/^\d+(\.\d+)?(px|%|em)$/] },
    th: { width: [/^\d+(\.\d+)?(px|%|em)$/] },
  },
};

const RichTextEditor = ({ text, selector }) => {
  const editor = useRef(null);
  const sanitizedText = useMemo(
    () => sanitizeHtml(text ?? "", SANITIZE_OPTIONS),
    [text]
  );

  useEffect(() => {
    const field = document.querySelector(selector);
    if (field) field.value = sanitizedText;
  }, [selector, sanitizedText]);

  const config = {
    readonly: false,
    height: 600,
    toolbar: true,
    toolbarAdaptive: false,
    showPlaceholder: false,
    language: "en",
    buttons: ["bold", "italic", "underline", "|", "paragraph", "ul", "ol"],
    extraButtons: [
      "undo",
      "redo",
      "outdent",
      "indent",
      "link",
      "unlink",
      "table",
    ],
    removeButtons: ["strikethrough", "eraser", "font"],
    disablePlugins: ["color"],
    showCharsCounter: false,
    showWordsCounter: false,
    events: {
      beforePasteInsert: (html) => sanitizeHtml(html, SANITIZE_OPTIONS),
    },
  };

  return (
    <JoditEditor
      ref={editor}
      value={sanitizedText}
      config={config}
      onChange={(text) => {
        document.querySelector(selector).value = text;
      }}
    />
  );
};

export default RichTextEditor;
